# One of the user's own proposals with its content (the link_schedule v1 snapshot), to open the
# assignation editor for it. The change summary is only computed by the listing. The approval
# history is only read for the rejection reason, while `rejectionReason` comes null.
query assignmentProposal($scenarioId: ID!, $originId: ID!, $linkId: ID!, $proposalId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    assignmentProposal(linkId: $linkId, proposalId: $proposalId) {
      errorCode
      content
      approvalTimeline {
        type
        comment
        __typename
      }
      proposal {
        id
        state
        status
        updatedAt
        rejectionReason
        comment
        requestedReviewers {
          username
          name
          lastName
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
